import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { WeekDays } from 'projects/Autofacets-Core/src/app/utils/enums';
import {BrandViewModelMultiSelector,VehicleTypeMultiSelector} from '../business-entities/brand-view-model-multiselector';
import { DealerRequestModel } from '../business-entities/dealer-view-model';
import { GenericResponse } from '../business-entities/generic-response';
import { MechanicLunchShiftViewModel } from '../business-entities/mechanic-opening-hours-view-model';
import { EditMechanicList, MechanicUserList } from '../business-entities/mechanicList-model';
import { UserRecipientViewModel } from '../business-entities/user-recipient-list-view.model';
import { MechanicDataService } from '../data-services/mechanic-data.service';
import { MechanicEfficiencyReportRequestModel, MechanicEfficiencyReportResponseModel} from '../business-entities/mechanic-efficiency-report-model';
import { MechanicAccuracyReportRequestModel, MechanicAccuracyResponseModel } from '../business-entities/mechanic-accuracy-report-model';
import {  MechanicTimeStampReportModel,  TimeStampResponseModel } from '../business-entities/time-stamp-report-model';
import { TotalSoldHoursReportResponseModel } from '../business-entities/total-sold-hours-report-model';
import {
  MechanicCustomerWaitingOccasionDeleteModel, MechanicCustomerWaitingOccasionSaveModel, MechanicCustomerWaitingOccasionViewModel,
  MechanicCustomerWaitingResultModel, MechanicCustomerWaitingSlotSaveModel, MechanicCustomerWaitingSlotViewModel
} from '../business-entities/mechanic-customer-waiting-hours-view-model';

@Injectable({
  providedIn: 'root'
})
export class MechanicService {
  dealerId: string;
  competenceId:number;
  mechanicId: number;
  entityId : number;
  timeCodeType : any;
  dealerList: Array<any>;
  isEdit : boolean = false;
  brandList: BrandViewModelMultiSelector[];
  mechanicName : string;
  // null until the mechanic details API responds
  isConsiderCustomerWaitingSlots$ = new BehaviorSubject<boolean | null>(null);
  mechanicEfficiency: GenericResponse<MechanicEfficiencyReportResponseModel>;
  mechanicAccuracy: GenericResponse<MechanicAccuracyResponseModel>;
  appointmentId:number=0;
  appointmentJobId:number =0;
  description:string ='';
  

  constructor(private service: MechanicDataService) {}

  GetMechanicList(id: string,status:number): Promise<any> {
    return this.service.GetMechanicList(id,status);
  }

  getDayText(dayId: number): string {
    switch (dayId) {
      case WeekDays.Sunday:
        return 'Sunday';
      case WeekDays.Monday:
        return 'Monday';
      case WeekDays.Tuesday:
        return 'Tuesday';
      case WeekDays.Wednesday:
        return 'Wednesday';
      case WeekDays.Thursday:
        return 'Thursday';
      case WeekDays.Friday:
        return 'Friday';
      case WeekDays.Saturday:
        return 'Saturday';
      default:
        return '';
    }
  }

  async getCompetence(status:number): Promise<any> {
    return this.service.getCompetence(status);
  }

  GetDealerList(dealerRequestModel:DealerRequestModel): Promise<any> {
    return this.service.GetDealerList(dealerRequestModel);
  }

  GetMechanicLeavesList(id: number): Promise<any> {
    return this.service.GetMechanicLeavesList(id);
  }

  AddMechanic(mechanicInfo: MechanicUserList) {
    return this.service.AddMechanic(mechanicInfo);
  }

  ValidateDmsMechanicId(id: any, dmsMechanicId: any) {
    return this.service.ValidateDmsMechanicId(id, dmsMechanicId);
  }

  AddMechanicLeaves(mechanicLeaves: any) {
    return this.service.AddMechanicLeaves(mechanicLeaves);
  }


  GetMechanicById(Id: number) {
    return this.service.GetMechanicById(Id);
  }

  GetMechanicLeavebyId(Id: number,MechanicLeaveRecurringId:number) {
    return this.service.GetMechanicLeavebyId(Id,MechanicLeaveRecurringId);
  }

  GetMechanicOpeningHoursById(Id: number,OccasionId:number) {
    return this.service.GetMechanicOpeningHoursById(Id,OccasionId);
  }

  GetDealerMechanicLunchShiftDetails(Id: number): Promise<GenericResponse<Array<MechanicLunchShiftViewModel>>> {
    return this.service.GetDealerMechanicLunchShiftDetails(Id);
  }


  UpdateMechanic(mechanicInfo: EditMechanicList): Promise<GenericResponse<any>> {
    return this.service.UpdateMechanic(mechanicInfo);
  }

  UpdateMechanicOpeningHours(shiftTime: any): Promise<GenericResponse<any>> {
    return this.service.UpdateMechanicOpeningHours(shiftTime);
  }

  GetMechanicCustomerWaitingOccasions(dealerId: string): Promise<GenericResponse<MechanicCustomerWaitingOccasionViewModel[]>> {
    return this.service.GetMechanicCustomerWaitingOccasions(dealerId);
  }

  AddUpdateMechanicCustomerWaitingOccasion(model: MechanicCustomerWaitingOccasionSaveModel): Promise<GenericResponse<MechanicCustomerWaitingResultModel>> {
    return this.service.AddUpdateMechanicCustomerWaitingOccasion(model);
  }

  DeleteMechanicCustomerWaitingOccasion(model: MechanicCustomerWaitingOccasionDeleteModel): Promise<GenericResponse<MechanicCustomerWaitingResultModel>> {
    return this.service.DeleteMechanicCustomerWaitingOccasion(model);
  }

  GetMechanicCustomerWaitingSlots(mechanicId: number, occasionId: number): Promise<GenericResponse<MechanicCustomerWaitingSlotViewModel[]>> {
    return this.service.GetMechanicCustomerWaitingSlots(mechanicId, occasionId);
  }

  SaveMechanicCustomerWaitingSlots(model: MechanicCustomerWaitingSlotSaveModel): Promise<GenericResponse<MechanicCustomerWaitingResultModel>> {
    return this.service.SaveMechanicCustomerWaitingSlots(model);
  }

  UpdateMechanicLeaves(mechanicLeaves: any): Promise<GenericResponse<any>> {
    return this.service.UpdateMechanicLeaves(mechanicLeaves);
  }

  DeleteLeave(leaveId: number) {
    return this.service.DeleteLeave(leaveId);
  }

  gtRecipientList(mechanicId:number): Promise<GenericResponse<Array<UserRecipientViewModel>>> {
    return this.service.getRecipientList(mechanicId);
  }

  getVehicleTypes(): Promise<GenericResponse<Array<VehicleTypeMultiSelector>>> {
    return this.service.getVehicleTypes();
  }

  async getBrand():Promise<any> {
    await this.service
       .getBrand()
       .then(
           (res: GenericResponse<Array<BrandViewModelMultiSelector>>) => {
               this.brandList = res.responseObject;
           }
       );

    return this.brandList;
  }

  AddEditMechanicCompetence(mechanicCompetence: any) {
    return this.service.AddEditMechanicCompetence(mechanicCompetence);
  }

  GetMechanicCompetenceByMechanicId(Id:number) :Promise<any>
  {
    return this.service.GetMechanicCompetenceByMechanicId(Id);
  }
  async getBrandsByCompetence(competenceid:number):Promise<any> {
    return this.service.getBrandsByCompetence(competenceid);
  }

  async getMechanicEfficiency(mechanicEfficiencyRequestModel: MechanicEfficiencyReportRequestModel): Promise<GenericResponse<MechanicEfficiencyReportResponseModel>> {
    await this.service.getMechanicEfficiencyReport(mechanicEfficiencyRequestModel)
      .then(
        (res: GenericResponse<MechanicEfficiencyReportResponseModel>) => {
          this.mechanicEfficiency = res;
        }
      );
    return this.mechanicEfficiency;
  }
  async GetMechanicReport(DealerId: string) :Promise<any>
  {
    return await this.service.GetMechanicReport(DealerId);
  }
  async GetServiceMechanicWiseByDealer(DealerId: string, language: string): Promise<any> {    
      return await this.service.GetServiceMechanicWiseByDealer(DealerId,language);    
  }

  async getMechanicAccracy(mechanicAccracyRequestModel: MechanicAccuracyReportRequestModel): Promise<GenericResponse<MechanicAccuracyResponseModel>> {
    await this.service.getMechanicAccracyReport(mechanicAccracyRequestModel)
      .then(
        (res: GenericResponse<MechanicAccuracyResponseModel>) => {
          this.mechanicAccuracy = res;
        }
      );
    return this.mechanicAccuracy;
  }
  async GetTimeStampReport(requestBody: any) :Promise<GenericResponse<Array<TimeStampResponseModel>>>{
    return await this.service.GetTimeStampReport(requestBody);
  }
  async getTotalSoldHoursReport(requestBody: any) : Promise<GenericResponse<TotalSoldHoursReportResponseModel>> {
    return await this.service.getTotalSoldHoursReport(requestBody);
  }
  async GetTimeStampDetails(requestBody: any) :Promise<GenericResponse<Array<TimeStampResponseModel>>>{
    return await this.service.GetTimeStampDetails(requestBody);
  }
  async ResyncMechanic(mechanicId: number): Promise<GenericResponse<boolean>> {
      return await this.service.ResyncMechanic(mechanicId);
  }
  async GetMechanicWorkTimeStampList(requestBody: any): Promise<GenericResponse<Array<MechanicTimeStampReportModel>>> {
    return await this.service.GetMechanicWorkTimeStampList(requestBody);
  }
  async GetMechanicLeaveTypes() {
    return await this.service.GetMechanicLeaveTypes();
   }
}
